<template>
  <div class="container page game-record-page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar page-nav">
      <template #left>
        <van-icon name="arrow-left" class="nav-back" @click="back()"/>
      </template>
    </van-nav-bar>
  <van-empty v-if="list.length === 0" :description="$t('my.msg46')" />
	<div v-for="(v,key) in list" :key="key" style="margin-bottom: 6px;width: 100%;padding: 5px 20px;background: #fff;">
		<div style="width: 100%;height: 60px;">
			<div v-if="v.win<=0" style="border-radius: 25px;color:#fff;text-align: center;font-size: 12px;line-height: 50px;width:50px;height: 50px;float: left;margin-left:0px ;margin-top: 13px;background: linear-gradient(0deg, rgb(250, 106, 165), rgb(243, 40, 121)); ;">
			<div v-if="v.status==1">Loss</div>
			<div v-if="v.status==0">Loading</div>
		</div>
		<div v-if="v.win>0" style="border-radius: 25px;color:#fff;text-align: center;font-size: 12px;line-height: 50px;width:50px;height: 50px;float: left;margin-left:0px ;margin-top: 13px;background: linear-gradient(0deg, rgb(104, 236, 110), rgb(9, 149, 61));">
			Win
		</div>
		
		<div style="font-weight: 600;float: left;margin-left:20px;text-align: left;line-height: 24px;">
			<div v-if="lang=='zh'" style="font-size: 14px;color: #292929;">{{v.lottery.name}}</div>
			<div v-if="lang=='ja'" style="font-size: 14px;color: #292929;">{{v.lottery.name_ja}}</div>
			<div v-if="lang=='en'" style="font-size: 14px;color: #292929;">{{v.lottery.name_es}}</div>
			<div v-if="lang=='kr'" style="font-size: 14px;color: #292929;">{{v.lottery.name_kr}}</div>
			<div style="font-weight: 500;;color: #a9a7b4">{{v.expect}}</div>
		
		</div><div v-if="v.win>0" style="font-weight: 600;float: right;margin-right: 0px;color: #09953d;line-height: 80px;">+{{v.win}}</div><div v-if="v.win<=0" style="font-weight: 600;float: right;margin-right: 0px;color: #f32879;line-height: 80px;">{{v.win}}</div>
		<div style="clear:both"></div>
		</div>
		<div style="width: 100%;line-height: 24px;padding: 0 10px 10px 10px;font-size: 10px;">
			<div style="width: 100%;text-align: left;display: inline-block;">
				<span style="font-weight: 700;color: #000;text-align: left;">{{$t('auth.top2')}}:</span>
                                <span style="font-weight: 500;color: #a9a7b4"><span v-for="(vs,keys) in v.wan" :key="keys" style="background: linear-gradient(90deg, #6667e8 0%, #5d63e1 100%);color: #fff;border-radius: 2.133vw;
				padding: 3px 5px;
				height: 7vw;
				line-height: 7vw;
				font-size: 3vw;
				font-weight: 700;text-align: center;margin-left: 3px;">{{ vs.name=='big'?rose:vs.name=='small'?lily:vs.name=='one'?fireworks:balloon }}</span></span>
			</div>
			<div style="width: 100%;">
				<span style="font-weight: 700;color: #000">{{$t('auth.top3')}}:</span><span style="font-weight: 500;color: #a9a7b4">
                                <span v-for="(vs,keys) in v.jie" :key="keys" style="background: linear-gradient(90deg, #6667e8 0%, #5d63e1 100%);color: #fff;border-radius: 2.133vw;
					padding: 3px 5px;
					height: 7vw;
					line-height: 7vw;
					font-size: 3vw;
					font-weight: 700;text-align: center;margin-left: 3px;">{{ vs.name=='big'?rose:vs.name=='small'?lily:vs.name=='one'?fireworks:balloon }}</span></span>
				</div>
			<div style="width: 100%;">
				<span style="font-weight: 700;color: #000">{{$t('auth.top1')}}:{{v.money}}</span>
			</div>
			{{$t('reservation.order_time')}}:{{v.create_time}}<br>{{$t('reservation.settle_time')}}:{{v.update_time}}
			<div style="clear:both"></div>
		</div>
		</div></div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      sum: '',
      double: '',fireworks:"",lang:this.$t("auth.lang"),
      size:""
      
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        const isEmptyResult = res.code === 401 && Array.isArray(res.data) && res.data.length === 0;
        if(res.code === 200 || isEmptyResult){
          const rows = Array.isArray(res.data) ? res.data : Object.values(res.data || {});
          this.list = rows;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
    }const lang = this.$t("auth.lang");
    if (lang == 'zh') {
      this.rose = '玫瑰';
      this.lily = '百合';
      this.balloon = '氣球'
      this.fireworks='煙花'
    } else if (lang == 'en') {
      this.rose = 'Rose';
      this.lily = 'Lily';
      this.balloon = 'Balloon'
      this.fireworks='Fireworks'
    } else if (lang == 'ja') {
      this.rose = 'バラは';
      this.lily = "リリー·リリー";
      this.balloon = '气球'
      this.fireworks='花火大会'
    } else {
      this.rose = '장미';
      this.lily = '백합';
      this.balloon = '풍선'
      this.fireworks='불꽃놀이'
    }
  },
  
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.game-record-page {
  min-height: 100%;
  background: #f5f5f5;
  padding: 10px 12px 24px;
  box-sizing: border-box;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #000;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{

}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list .period-number{
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #000;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 35px;
}
.ressquareBox{
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    border-radius: 16px;
    margin-left: 20px;
    padding:  13px 40px;
    min-width: 13vw;
}

.nav-back {
  color: #8795ad;
}

::v-deep .page-nav {
  background: #fff;
  margin: -10px -12px 16px;
}

::v-deep .page-nav .van-nav-bar__title {
  color: #000;
}

::v-deep .page-nav::after {
  border-bottom: 1px solid #ededed;
}
</style>
